import { SEOBreadcrumb } from '../../types'
import { makeId } from '../utils'

export interface SEOGetBreadcrumbInput {
  canonicalUrl: string
  name: string
  artifactProps?: Record<string, string>
  hasHome?: boolean
}

export const getBreadcrumb = ({
  name,
  canonicalUrl,
  artifactProps,
  hasHome = true,
}: SEOGetBreadcrumbInput): SEOBreadcrumb => ({
  '@type': 'BreadcrumbList',
  '@id': makeId(canonicalUrl, 'breadcrumb'),
  itemListElement: [
    ...(hasHome
      ? [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: 'https://www.jusbrasil.com.br',
          },
        ]
      : []),
    ...(artifactProps
      ? [
          {
            '@type': 'ListItem',
            position: hasHome ? 2 : 1,
            name: artifactProps.label,
            item: `https://www.jusbrasil.com.br/${artifactProps.pathSegment}/`,
          },
        ]
      : []),
    {
      '@type': 'ListItem',
      position: hasHome && artifactProps ? 3 : artifactProps || hasHome ? 2 : 1,
      name,
      item: canonicalUrl,
    },
  ],
})
